export const styledRelatorioListUsuario = (orientation: 'portrait' | 'landscape'): string => {
    return `
        /* ============================================
           Listagem de Usuários - IMPRESSÃO
           
           HEADER (apenas na primeira página):
           - Altura: 120px
           - Alinhado no topo (align-items: flex-start)
           
           FOOTER (apenas na última página):
           - Altura: 250px
           - Sempre no final da página (margin-top: auto)
           
           CONTEÚDO PRINCIPAL:
           - padding-left/right: 15mm (alinhamento com header)
           ============================================ */


        /* Elementos que não serão mostrados na tela, apenas no print */
        .header-report,
        .footer-report {
            display: none !important;
        }

        .logo-img {
            max-height: 80px;
            max-width: 180px;
            object-fit: contain;
        }

        @media print {
            html,
            body {
                height: auto !important;
                overflow: hidden !important;
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
                background-color: #FFF !important;
            }

            @page {
                size: A4 ${orientation} !important;
                margin: 0mm !important;
                margin-top: 9mm !important;
                margin-bottom: 8mm !important;
                margin-left: 7mm !important;
                margin-right: 7mm !important;
            }


            /* Esconde o cabeçalho original com título e botão */
            .header-print-hide {
                display: none !important;
            }

            /* ============================================
               HEADER - APENAS NA PRIMEIRA PÁGINA
               ============================================ */
            .header-report {
                display: flex !important;
                position: relative !important;
                width: 100% !important;
                margin-bottom: 25px !important;
                align-items: flex-start !important;
                justify-content: space-between !important;
                page-break-after: avoid !important;
            }

            .header-info h1 {
                font-size: 22px !important;
                font-weight: bold !important;
                color: #1e293b !important;
                margin: 0 !important;
                padding: 0 !important;
                max-width: 100%;
            }

            .header-info p {
                font-size: 1.125rem !important;
                color: #6b7280 !important;
            }

            .header-logo img {
                max-width: 150px !important;
                max-height: 80px !important;
                object-fit: contain !important;
            }

            /* ============================================
               FOOTER - APENAS NA ÚLTIMA PÁGINA, SEMPRE NO FINAL
               ============================================ */
            .footer-report {
                flex: 1 !important;
                display: flex !important;
                flex-direction: column !important;
                position: relative !important;
                width: 100% !important;
                margin-top: auto !important;
                margin-bottom: 0 !important;
                bottom: 0 !important;
                page-break-before: avoid !important;
                align-items: center !important;
                justify-content: center !important;
            }

            .footer-report-img {
                z-index: -1 !important;
                width: 100% !important;
                height: 250px !important;
                margin-bottom: -1px !important;
                display: block !important;
            }

            .footer-report-date-generated {
                padding: 5px 0 !important;
                text-align: center !important;
                width: 100% !important;
                font-size: 12px !important;
                z-index: 1000 !important;
                bottom: 0 !important;
            }

            .footer-report-date-generated > p {
                color: #000 !important;
                font-size: 14px !important;
            }

            /* ============================================
               ESPAÇAMENTOS DO CONTEÚDO PRINCIPAL
               ============================================ */
            
            .report-content {
                position: relative !important;
                min-height: 100vh !important;
                display: flex !important;
                flex-direction: column !important;
            }

            .page {
                padding-top: 10px !important;
                padding-bottom: 10px !important;
                page-break-before: auto !important;
                flex: 1 !important;
            }

            .page .ant-table-tbody > tr {
                page-break-inside: avoid !important;
                break-inside: avoid !important;
            }

            .tableRelatorioListUsuario_wrapper {
                margin: 0 !important;
                padding: 0 !important;
            }

            .tableRelatorioListUsuario_wrapper .ant-table-wrapper {
                margin-bottom: 0 !important;
            }

            .tableRelatorioListUsuario_wrapper .ant-table-wrapper {
                background-color: #fff !important;
                overflow: hidden !important;
                overflow-x: hidden !important;
            }

            .tableRelatorioListUsuario_wrapper .ant-table-wrapper > div {
                overflow: hidden !important;
                overflow-x: hidden !important;
            }

            .tableRelatorioListUsuario_wrapper .ant-table-wrapper > div > div {
                overflow: hidden !important;
                overflow-x: hidden !important;
            }

            .tableRelatorioListUsuario_wrapper .ant-table-wrapper > div > div > div {
                overflow: hidden !important;
                overflow-x: hidden !important;
            }

            .tableRelatorioListUsuario_wrapper .ant-table-wrapper > div > div > div > div {
                overflow: hidden !important;
                overflow-x: hidden !important;
            }

            .tableRelatorioListUsuario_wrapper .ant-table-wrapper > div > div > div > div > div {
                overflow: hidden !important;
                overflow-x: hidden !important;
            }

            .tableRelatorioListUsuario_wrapper .ant-table-wrapper .ant-table-container {
                overflow: hidden !important;
                overflow-x: hidden !important;
            }

            .tableRelatorioListUsuario_wrapper .ant-table-wrapper .ant-table-body {
                overflow: hidden !important;
                overflow-x: hidden !important;
            }

            .tableRelatorioListUsuario_wrapper .ant-table-wrapper table {
                width: 100% !important;
            }

            div.ant-table-wrapper > div > div > div > div.ant-table-title > div {
                background-color: #FAFAFA !important;
            }


            /*CLASSES DO ANTD TABLE E COMPONENTS*/

            .ant-table-cell {
                color: #000 !important;
                background-color: #FFF !important;
                -webkit-text-size-adjust: 100%;
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
                -webkit-font-smoothing: antialiased;
                color: rgba(0, 0, 0, 0.85);
                font-variant: tabular-nums;
                line-height: 1.5715;
                list-style: none;
                font-feature-settings: 'tnum', "tnum";
                font-size: 7.5px;
                text-align: left;
                border-collapse: separate;
                border-spacing: 0;
                box-sizing: border-box;
                border-color: #f0f2f5 !important;
            }

            :where(.css-dev-only-do-not-override-1wux801).ant-table-wrapper .ant-table-thead>tr>th,
            :where(.css-dev-only-do-not-override-1wux801).ant-table-wrapper .ant-table-thead>tr>td {
                background-color: #e4e4e4 !important;
                color: #000 !important;
            }

            :where(.css-dev-only-do-not-override-1wux801).ant-table-wrapper .ant-table {
                background-color: #fff !important;
            }

            .ant-typography:not(.color-danger) {
                color: #000 !important;
            }

            div>div>div>div.ant-table-wrapper>div>div>div {
                background-color: #fff !important;
                border: 0px !important;
            }

            .ant-typography:not(.text_valorEstimado_hjlbcveqwov) {
                font-size: 7.5px !important;
            }

            div>.ant-typography {
                font-size: 7.5px !important;
            }

            .ant-table-body {
                -webkit-text-size-adjust: 100%;
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                --antd-wave-shadow-color: #1890ff;
                --scroll-bar: 0;
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
                -webkit-font-smoothing: antialiased;
                color: rgba(0, 0, 0, 0.85);
                font-variant: tabular-nums;
                line-height: 1.5715;
                list-style: none;
                font-feature-settings: 'tnum', "tnum";
                font-size: 7.5px;
                text-align: left;
                border-collapse: separate;
                border-spacing: 0;
                box-sizing: border-box;
            }

            .ant-table-footer {
                background-color: #FAFAFA !important;
            }

            .ant-table-title {
                background-color: #FAFAFA !important;
            }

            .ant-select-selector {
                -webkit-text-size-adjust: 100% !important;
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0) !important;
                --antd-wave-shadow-color: #1890ff !important;
                --scroll-bar: 0 !important;
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
                -webkit-font-smoothing: antialiased !important;
                color: rgba(0, 0, 0, 0.85) !important;
                font-size: 7.5px !important;
                font-variant: tabular-nums !important;
                line-height: 1.5715px !important;
                list-style: none !important;
                font-feature-settings: 'tnum', "tnum" !important;
                box-sizing: border-box !important;
                display: flex !important;
                width: 100% !important;
                height: 18px !important;
                padding: 0 2px !important;
                position: relative !important;
                background-color: #fff !important;
                border: 1px solid #d9d9d9 !important;
                border-radius: 2px !important;
                transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
                cursor: text !important;
                align-items: center !important;
                justify-content: center !important;
            }

            .ant-tag {
                font-size: 6.5px !important;
                line-height: 10px !important;
                padding: 2px !important;
                color: #000000e0 !important;
                border: 1px solid #d9d9d9 !important;
                background: #fafafa !important;
                white-space: inherit !important;
                box-sizing: border-box !important;
                margin: 0 !important;
                border-color: #d9d9d9 !important;
            }

            .ant-select-multiple .ant-select-selection-item {
                border: 1px solid #d9d9d9 !important;
                background: #fafafa !important;
            }

            span>.ant-tag {
                font-size: 7px !important;
                white-space: inherit !important;
                border-color: #d9d9d9 !important;
            }

            .ant-table-container {
                background-color: #FFF !important;
                -webkit-text-size-adjust: 100%;
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                --antd-wave-shadow-color: #1890ff;
                --scroll-bar: 0;
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
                -webkit-font-smoothing: antialiased;
                color: rgba(0, 0, 0, 0.85);
                font-variant: tabular-nums;
                line-height: 1.5715;
                list-style: none;
                font-feature-settings: 'tnum', "tnum";
                font-size: 14px;
                box-sizing: border-box;
                border-top-left-radius: 0;
                border-top-right-radius: 0;
                position: relative;
            }

            div.ant-table-container>div>table>thead>tr>th>div>span.ant-dropdown-trigger.ant-table-filter-trigger>span>svg {
                font-size: 7px !important;
            }

            div.ant-table-container>div>table>thead>tr>th>div>span.ant-table-column-title>div>span.ant-table-column-sorter.ant-table-column-sorter-full>span>span.anticon.anticon-caret-up.ant-table-column-sorter-up>svg {
                font-size: 7px !important;
            }

            div.ant-table-container>div>table>thead>tr>th>div>span.ant-table-column-title>div>span.ant-table-column-sorter.ant-table-column-sorter-full>span>span.anticon.anticon-caret-down.ant-table-column-sorter-down>svg {
                font-size: 7px !important;
            }

            .ant-select {
                font-size: 7.5px !important;
            }

            .ant-pagination {
                display: none !important;
            }

        }

    `;
};
